var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _vm.deepGet(_vm.form, 'config.thanks_page.banner_image') ? _c('img', {
    staticClass: "banner-image w-100",
    attrs: {
      "src": _vm.deepGet(_vm.form, 'config.thanks_page.banner_image')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.deepGet(_vm.form, 'config.thanks_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.thanks_page.form_title')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.thanks_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.thanks_page.form_desc')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.thanks_page.content') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.form, 'config.thanks_page.content'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.deepGet(_vm.form, 'config.thanks_page.button_text'),
      "button-url": _vm.deepGet(_vm.form, 'config.thanks_page.button_url'),
      "type": _vm.deepGet(_vm.form, 'config.thanks_page.button_action')
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }